import { render, staticRenderFns } from "./NotificationActivity.vue?vue&type=template&id=1cb385b0&scoped=true"
import script from "./NotificationActivity.vue?vue&type=script&lang=js"
export * from "./NotificationActivity.vue?vue&type=script&lang=js"
import style0 from "./NotificationActivity.vue?vue&type=style&index=0&id=1cb385b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb385b0",
  null
  
)

export default component.exports